export default {
    zh: {
        ssrNo: 'SSR Number',
        ssrName: 'SSR Name ',
        releaseDate: 'Release Date',
        updateDate: 'Update Time',
        specUpload: 'Upload Spec',
        ssrInitiate: 'Release SSR',
        proposal: 'Proposal',
        recommendation: 'Recommendation',
        bc: 'BC',
        category1: 'Category1',
        category2: 'Category2',
        description: 'Product Description',
        marketScope: 'Market Scope',
        ssrObjective: 'SSR Objective',
        announce: 'Publish',
        supplierList: 'Supplier List',
        invitationCode: '供应商编码',
        supplierNameShort: '供应商名称',
        supplierRoundStatus: 'Round Status',
        supplierRoundSubmitDate: 'Submission Time',
        supplierStatus: 'Supplier Status',
        dc: '仓库',
        dcAddress: '仓库地址',
        nature: '类型',
        supplierName: 'Supplier Name',
        supplierEnName: 'Supplier En Name',
        isSupplier: '是否正式供应商',
        contacts: 'Contact',
        email: 'E-mail',
        selSupplierTitle: 'Select Supplier',
        plantName: 'Facility Name',
        scheduleTitle: 'Schedule of Events',
        projectItem: 'Project Item',
        beginDate: 'Start Date',
        timeline: 'End Date',
        remark: 'Remark',
        round: 'Release',
        roundNum: 'Round',
        roundTitle: 'Round：{0}',
        roundEndDate: 'Round End Time：',
        ssrCqs: 'SSR-CQS',
        ssrDetailSS: 'SSR Detail-SS',
        ssrDetailSup: 'SSR Detail-Supplier',
        upAdd: 'Add Up',
        downAdd: 'Add Below',
        baseInfoPane: 'SSR Detail',
        supplierPane: 'Proposal',
        offerInfoPane: 'PQCP',
        costInfoPane: 'Cost Breakdown',
        productionInfoPane: 'Capacity Analysis',
        logisticsPane: 'Logistics Capacity',
        createBc: 'Create BC',
        spmCorePane: 'SPM',
        stateChangePane: 'Log',
        proposalDoc: 'Proposal',
        submitDate: 'Submission Date',
        summarize: 'Proposal Overview',
        downloadAttac: 'Download Attachment',
        otherFormat: 'Other Format',
        offerDownload: 'Download',
        roundsIssue: 'Publish',
        breakUp: 'Termination',
        roundsEnd: 'Round End',
        biding: 'Accept',
        refuse: 'Reject',
        refuseRemark: 'Please confirm that you want to reject the invitation？',
        availablePalletNum: '可供使用拍位数',
        totalPalletNum: 'Total Number Of Stock Positions',
        temperature_normal: '常温',
        temperature_cold: '冷藏',
        temperature_frozen: '冷冻',
        freeCarNumber: '自由车辆数量',
        outSourcingCarNumber: '外协车辆数量',
        scheduleDateError: 'Schedule Date Error！',
        supplierListCannotBeEmpty: 'Please Fill The Supplier List！',
        needPqcp: 'Please Fill The PQCP！',
        needCostBreakdown: 'Please Fill The Cost Breakdown！',
        needCapacityAnalysis: 'Please Fill The Capacity Analysis！',
        needLogisticCapacity: 'Please Fill The Logistics Capacity！',
        needOtherFormat: 'Please Upload Other Format！',
        needSuspendRemark: 'Please fill the remark！',
        reviewOutcomeError: 'Review Outcome Error！',
        bcCreated: '供应商对应BC任务已创建',
        eightBitCodeError: '请输入可用物料!',
        supStatusDraft: 'UnSubmitted',
        supStatusSubmit: 'Submitted',
        supStatusContinue: 'Advance To Next Round',
        supStatusDistinue: 'Out',
        supStatusRecommendation: 'Recommendation',
        supStatusRefuse: 'Waiver',
        shareMark: 'Share Score',
        shareMarkSuccess: 'Rating shared',
        copyToNewRound: "复制到最新轮次",
        useRatioError: "当前信息不符合规则",
        selectPqcpOrder: "Select PQCP Order",
        orderBySupplier: "Order By Supplier",
        orderByPrice: "Order By Price",
        publish: "Publish",
        customize: "Customize",
        downloadTemplate: "Template",
        supDownloadTemplate: "Download Template",
        capacityTemplateFile: 'Capacity Analysis Template',
        greMsg: 'Not Started',
        redMsg: 'Overdue > 2 Weeks',
        yellowMsg: 'Overdue ≤ 2 Weeks',
        greenMsg: 'On Schedule',
        noCapacityFiles: 'Can Not Find Capacity Analysis Template',
        proposeRequire: 'Please fill the field with *',
    },
    en: {}
}